<template>
	<TopTab />
	<div class="art-container">

		<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
			<van-swipe-item v-for="item in bannerList" :key="item.id">
				<div class="banner" :style="{ backgroundImage: `url(${item.carouselImg})` }"></div>
			</van-swipe-item>
		</van-swipe>

		<div class="tab">
			<b>ART 艺术鉴赏</b>
			<span @click="router.push('/art-more?type=1')">更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="news">
			<NewsItem v-for="item in newsList" :data="item" />
		</div>

		<div class="sep_line"></div>
		
		<div class="tab">
			<b>CULTURAL RELIC 文物鉴赏</b>
			<span @click="router.push('/art-more?type=2')">更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="relic-news">
			<ul>
				<li v-for="item in relicNewsList" @click.stop="router.push({path: '/art-detail', query: {id: item.id}})">
					<h5>{{ item.artName }}</h5>
					<img :src="item.mainImage" alt="">
				</li>
			</ul>
		</div>

		<div class="sep_line"></div>

		<div class="tab">
			<b>CHARACTER 人物专栏</b>
			<span @click="router.push('/art-more?type=3')">更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="character" v-if="characterList.length > 0">
			<div class="l" :style="{ backgroundImage: `url(${characterList[0].mainImage})` }" @click.stop="router.push({path: '/art-detail', query: {id: characterList[0].id}})">
				<p>{{ characterList[0].artName }}</p>
			</div>
			<div class="r">
				<div class="t" :style="{ backgroundImage: `url(${characterList[1].mainImage})` }" @click.stop="router.push({path: '/art-detail', query: {id: characterList[1].id}})">
					<p>{{ characterList[1].artName }}</p>
				</div>
				<div class="b" :style="{ backgroundImage: `url(${characterList[2].mainImage})` }" @click.stop="router.push({path: '/art-detail', query: {id: characterList[2].id}})">
					<p>{{ characterList[2].artName }}</p>
				</div>
			</div>
		</div>

		<div class="sep_line"></div>
		
		<div class="tab">
			<b>INFORMATION CHIT-CHAT 资讯杂谈</b>
			<span @click="router.push('/art-more?type=4')">更多<van-icon name="arrow-double-right" /></span>
		</div>

		<div class="information-chat">
			<ul>
				<li v-for="item in informationChatList" @click.stop="router.push({path: '/art-detail', query: {id: item.id}})">
					<img :src="item.bannerUrl" />
					<h5>{{ item.artName }}</h5>
					<div class="content">
						<span>作者：{{ item.updateBy }}</span>
						<div class="icons">
							<img src="@/assets/imgs/icon5.png" alt=""> {{ item.browseCount }}
							<img src="@/assets/imgs/icon6.png" alt=""> {{ item.thumbsUpCount }}
						</div>
					</div>
				</li>
			</ul>
		</div>

	</div>
	<FooterBar />
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, ref, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import * as api from '@/request/front'
import { richTextToPlainText } from '@/utils/util.js'
import NewsItem from '@/views/front/components/NewsItem.vue'
import FooterBar from '@/views/front/components/FooterBar.vue'
const router = useRouter()
const bannerList = ref([])
const newsList = ref([])
const relicNewsList = ref([])
const characterList = ref([])
const informationChatList = ref([])
onMounted(() => {
	api.getBannerList(273).then(res => {
		bannerList.value = res.data.rows
	})
	fetchNewsList()
	getRelicNewsList()
	getCharacterList()
	getInformationChatList()
})

function fetchNewsList() {
	api.getNewsList(1, 2).then(res => {
		newsList.value = res.data.rows
	})
}

function getRelicNewsList() {
	api.getNewsList(2, 3).then(res => {
		relicNewsList.value = res.data.rows
	})
}

function getCharacterList() {
	api.getNewsList(3, 3).then(res => {
		characterList.value = res.data.rows
	})
}

function getInformationChatList() {
	api.getNewsList(4, 3).then(res => {
		informationChatList.value = res.data.rows
	})
}



</script>

<style scoped lang="scss">
.art-container {
	padding-bottom: 50rem;

	.my-swipe {
		width: 100%;
		height: 160rem;

		.banner {
			width: 100%;
			height: 100%;
			background-size: cover;
			background-position: center;
		}
	}

	.tab {
		display: flex;
		justify-content: space-between;
		padding: 20rem 15rem;

		span {
			font-size: 14rem;
			color: #8A8A8A;
		}
	}

	.news {
		ul {
			li {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 20rem;
				position: relative;
				height: 90rem;
				padding: 0 20rem;

				.banner_img {
					width: 112rem;
					height: 100%;
					background-size: cover;
					background-position: center;
					margin-right: 10rem;
				}

				.content {
					width: 60%;
					height: 100%;

					h5 {
						font-size: 14rem;
						color: #000;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}

					p {
						margin-top: 5rem;
						font-size: 12rem;
						height: 40rem;
						line-height: 20rem;
						width: 100%;
						color: #999;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.icons {
						position: absolute;
						right: 5rem;
						bottom: 0;
						color: #999;

						img {
							width: 15rem;
							height: auto;
							margin: 0 5rem;
						}
					}
				}
			}
		}
	}

	.relic-news {
		padding: 20rem;

		ul {
			display: flex;
			justify-content: space-between;

			li {
				width: 127rem;
				height: 184rem;
				background: linear-gradient(180deg, rgba(255, 0, 0, 0.2) 0%, #FFFFFF 100%);
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				img {
					max-width: 100rem;
					max-height: 100rem;
				}

				h5 {
					font-size: 12rem;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					text-align: center;
					color: #000000;
					font-family: '仿宋';
					margin-bottom: 10rem;
				}
			}

			li:nth-child(even) {
				background: linear-gradient(180deg, rgba(48, 48, 48, 0.2) 0%, #FFFFFF 100%);
			}
		}
	}

	.character {
		display: flex;
		justify-content: space-between;
		padding: 0 15rem;

		.l {
			width: 180rem;
			height: 180rem;
			background-size: cover;
			background-position: center;
			position: relative;
		}

		.r {
			.t {
				width: 206rem;
				height: 84rem;
				margin-bottom: 12rem;
				position: relative;
				background-size: cover;
				background-position: center;
			}

			.b {
				width: 206rem;
				height: 84rem;
				position: relative;
				background-size: cover;
				background-position: center;
			}
		}

		p {
			position: absolute;
			padding: 0 5rem;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 20rem;
			line-height: 20rem;
			text-align: center;
			font-size: 12rem;
			color: #fff;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.information-chat{
		padding: 0 15rem;
		ul{
			li{
				width: 100%; margin: 15rem 0;
				>img{
					width: 100%;
					height: 200rem;
				}
				h5{font-weight: normal; margin: 5rem 0;}
				.content{
					display: flex; justify-content: space-between; color: #999999;
					.icons{
						display: flex; align-items: center;
						img{
							width: 25rem; margin:0 5rem ;
						}
					}
				}
			}
		}
	}
}
</style>
